import Alpine from "alpinejs"
import { intersect } from "@alpinejs/intersect"
import { verifyRecaptcha } from "./recaptcha"
import { trackDataLayerEvent } from "./dataLayer"
import { sendStoredFormEvents } from "./formTracking"

export default function initAlpine() {
  Alpine.plugin(intersect)

  Alpine.data(
    "newsletterModal",
    (initState = { enabled: true, buttonMode: false }) => ({
      newsletterModalReady: false,
      newsletterModalOpen: false,
      newsletterModalDontShowAgain: false,
      newsletterModalDisabled: false,
      newsletterModalIsButtonMode: false,
      initNewsletterModal() {
        this.newsletterModalDisabled = !initState.enabled

        // Below logic is turned off for now on client request
        //
        // this.newsletterModalIsButtonMode = initState.buttonMode;
        //
        // if (this.newsletterModalDisabled) return;
        // const openBtn = this.$refs.nlmOpenButton
        // openBtn.addEventListener('click', () => {
        //   this.openNewsletterModal();
        // });
        // document.body.appendChild(openBtn);
        //
        // if (!this.isFundPage) {
        //   if (this.newsletterModalIsButtonMode) {
        //     this.setOpenButtonVisible(true);
        //   } else {
        //     this.startNewsletterModalTimer();
        //   }
        // }
      },
      startNewsletterModalTimer() {
        // Timer turned off on client request so this method is currently not used
        setTimeout(
          () => {
            this.openNewsletterModal()
          },
          15000 // 15 seconds
        )
      },
      openNewsletterModal() {
        console.log("bum")
        if (this.newsletterModalDisabled) return

        this.$refs.nlmModal.style.display = "block"

        document
          .querySelector(".popup-backdrop")
          .addEventListener("click", () => this.closeNewsletterModal())

        this.newsletterModalOpen = true
        this.popupBackdrop = true

        trackDataLayerEvent("newsletter_popup_view")

        // this.setOpenButtonVisible(false);
      },
      closeNewsletterModal() {
        this.newsletterModalOpen = false
        this.popupBackdrop = false

        if (this.newsletterModalDontShowAgain) {
          const oneYearSeconds = 365 * 24 * 60
          this.newsletterModalDisabled = true
          setCookie("nlm_no_show", 1, oneYearSeconds)
          console.log("Newsletter modal disabled")
        } else {
          const oneWeekSeconds = 7 * 24 * 60
          setCookie("nlm_button_mode", 1, oneWeekSeconds)
          // this.setOpenButtonVisible(true);
        }
      },
      setOpenButtonVisible(visible) {
        // Floating button turned off on client request so this method is currently not used
        if (this.isFundPage) return

        this.$refs.nlmOpenButton.style.display = visible ? "block" : "none"
      },
    })
  )

  // Opens the prelaunch popup when the "our mission" section scrolls into view, or
  // after 5 seconds if the user has not scrolled there yet (whichever comes first).
  window.setupPrelaunchPopup = (onOpen) => {
    let opened = false
    let timer = null
    let observer = null

    const open = () => {
      if (opened) return
      opened = true
      if (timer) clearTimeout(timer)
      if (observer) observer.disconnect()
      onOpen()
    }

    const storySection = document.querySelector("#our-mission")
    if (storySection) {
      let initialCallback = true
      observer = new IntersectionObserver(
        (entries) => {
          if (initialCallback) {
            initialCallback = false
            return
          }
          if (entries.some((entry) => entry.isIntersecting)) open()
        },
        { threshold: 0.2 }
      )
      observer.observe(storySection)
    }

    timer = setTimeout(open, 5000)
  }

  window.markPrelaunchPopupSeen = () => {
    const oneYearSeconds = 365 * 24 * 60
    setCookie("prelaunch_popup_seen", 1, oneYearSeconds)
  }

  Alpine.data("ajax", (initState = {}) => ({
    loading: false,
    interactive: false,
    state: initState,
    getBody() {
      let formData = null
      if (this.$el instanceof HTMLFormElement) formData = new FormData(this.$el)
      if (this.$root instanceof HTMLFormElement)
        formData = new FormData(this.$root)
      // needed for isSubmittedBy nette method
      if (formData && this.$el instanceof HTMLButtonElement)
        formData.append(this.$el.name, this.$el.value)
      if (
        formData &&
        this.$el instanceof HTMLInputElement &&
        this.$el.type === "reset"
      )
        formData.append(this.$el.name, this.$el.value)
      if (formData && this.$event.submitter instanceof HTMLButtonElement)
        formData.append(this.$event.submitter.name, this.$event.submitter.value)
      return formData
    },
    getUrl() {
      if (this.$el instanceof HTMLFormElement) return this.$el.action
      if (this.$root instanceof HTMLFormElement) return this.$root.action
      if (this.$el instanceof HTMLAnchorElement) return this.$el.href
      return initState.url
    },
    propagate() {
      this.$el.closest("form").dispatchEvent(new Event("request"))
    },
    trackEvent(event, oneTime = false) {
      trackDataLayerEvent(event, oneTime)
    },
    async request(body = null) {
      this.loading = true
      await verifyRecaptcha(this.$el)
      return fetch(this.getUrl(), {
        method: body || this.getBody() ? "POST" : "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: body || this.getBody(),
      })
        .then((response) => {
          if (response.redirected) location.href = response.url
          return response.json()
        })
        .then(({ snippets, success, trackEvents, redirect, url }) => {
          const form =
            this.$el instanceof HTMLFormElement ? this.$el : this.$el.form
          const submitEvent = form?.dataset.submitTrackEvent ?? null
          const submitNoTrack = form?.dataset.submitNoTrack === "1"

          if (success && trackEvents)
            trackEvents.forEach((event) => trackDataLayerEvent(event))
          if (
            success &&
            !submitNoTrack &&
            submitEvent &&
            submitEvent.length > 0
          )
            trackDataLayerEvent(submitEvent)
          if (redirect) {
            location.href = redirect
          } else {
            // After a redirect the next page load sends them, pushing now could be lost mid-navigation
            sendStoredFormEvents()
          }

          if (snippets) {
            if (url) {
              window.history.pushState(snippets, "", url)
            }
            const updatedElements = applySnippets(snippets)
            window.dispatchEvent(new Event("resize")) // Adjusts section sizes for the scroll effect
            scrollToHighestElement(updatedElements, 250)
            this.interactive = true
            this.loading = false
            document.dispatchEvent(new Event("ajaxSnippetUpdate"))
          }
        })
        .catch((e) => {
          console.warn(e)
          this.loading = false
        })
    },
  }))

  function applySnippets(snippets) {
    const updatedElements = []
    for (const [id, html] of Object.entries(snippets)) {
      const element = document.getElementById(id)
      if (element) {
        element.innerHTML = html
        updatedElements.push(element)
      }
    }
    return updatedElements
  }

  function scrollToHighestElement(elements, offsetPx) {
    const topValues = elements.map(
      (element) => element.getBoundingClientRect().top
    )
    const max = Math.max(...topValues)
    const index = topValues.indexOf(max)

    const elementTop = elements[index].getBoundingClientRect().top
    const elementScrollTop = window.scrollY + elementTop

    window.scrollTo({
      top: elementScrollTop - offsetPx, // Add a bit of offset
      behavior: "smooth",
    })
  }

  function setCookie(name, value, maxAge, path = "/", sameSite = "Lax") {
    document.cookie = `${name}=${value}; path=${path}; max-age=${maxAge}; SameSite=${sameSite}`
  }

  window.Alpine = Alpine
  Alpine.start()
}
